"use client";

import { cn } from "@/lib/utils";
import Image from "next/image";

interface ImageBackgroundProps {
  staticImageUrl: string;
  className?: string;
  backdropClassName?: string;
  priority?: boolean;
}

export function ImageBackground({
  staticImageUrl,
  className,
  backdropClassName,
  priority = false,
}: ImageBackgroundProps) {
  return (
    <div
      className={cn(
        "fixed inset-0 z-0 pointer-events-none min-h-lvh overflow-hidden",
        className,
      )}
    >
      <Image
        src={staticImageUrl}
        alt=""
        fill
        priority={priority}
        fetchPriority={priority ? "high" : "auto"}
        className="object-cover object-center animate-in fade-in duration-1000"
        sizes="100vw"
      />
      <div className={cn("absolute inset-0 bg-black/30", backdropClassName)} />
    </div>
  );
}
